import { ADD_DISH, ADD_NEW_DISH, CLEAR_ORDER, REMOVE_DISH, REMOVE_DISH_WITH_OPTIONS, REPLACE_DISH } from '../constants/menu';
import { clone, get } from '@utils/lo/lo';
import api from '@api';
import { toastr } from 'react-redux-toastr';
import mova from 'mova';
import store from '@store/Store';
import { closeModal, openModal } from './modal';
import { LOGIN_MODAL } from '../constants/modal';
import { v4 as uuidv4 } from 'uuid';
import { getPaymentLink } from './billing';

const likeT = mova.ns('types.likes');
const orderT = mova.ns('types.orders');

export const addDish = (dish) => dispatch => {
  const place = store.getState().place.details?.data;
  dispatch({ type: ADD_DISH, payload: dish, place });
};

export const addNewDish = (dish) => (dispatch) => {
  const place = store.getState().place.details?.data;
  dispatch({ type: ADD_NEW_DISH, payload: dish, place });
};

export const removeDish = (dish) => dispatch => {
  const place = store.getState().place.details?.data;
  dispatch({ type: REMOVE_DISH, payload: dish, place });
};

export const removeDishWithOptions = (order) => dispatch => {
  const place = store.getState().place.details?.data;
  dispatch({ type: REMOVE_DISH_WITH_OPTIONS, payload: order, place });
};

export const placeOrder = ({ orderDishes, comment, spotId }) => async dispatch => {
  const place = store.getState().place.details?.data;
  const apiRequest = get(api, 'order.placeOrder');

  const formattedDishes = orderDishes.map(d => ({
    count: d.count,
    dish: { id: d.id },
    options: d.options || [],
  }));

  const order = await apiRequest(place.uri, {
    orderDishes: formattedDishes,
    comment: comment || '',
    spotId,
  });
  if (place.clientOrdersPrepayment) {
    const clientId = uuidv4().substring(0, 8);
    const body = {
      orderId: order.data.orderId,
      reservationId: order.data.reservationId,
      description: 'RESERVATION_ORDER_PREPAY_ORDER',
      amount: order.data.amount,
      clientId: clientId,
      successUrl: window.location.href + `&clear_order=true`,
      failedUrl: window.location.href,
    }
    const link = await dispatch(getPaymentLink(place.uri, body));
    window.location = link.data.paymentLink;
  } else {
    dispatch({ type: CLEAR_ORDER, payload: place });
    dispatch(closeModal());
    toastr.success(orderT('placed'));
  }
};

export const toggleLikeDish = (e, dish) => (dispatch) => {
  e.stopPropagation();
  const isLoggedIn = !!store.getState().user.details.data?.user?.id;

  if (!isLoggedIn) {
    dispatch(openModal(LOGIN_MODAL));
    return;
  }

  const like = {
    targetId: dish.id,
    type: 'dish',
  };

  const apiRequest = get(api, 'places.toggleLike');
  apiRequest(like)
    .then((res) => {
      const updatedDish = clone(dish);
      updatedDish.isLiked = res.data.isLiked;
      dispatch({ type: REPLACE_DISH, payload: updatedDish });

      const text = res.data.isLiked ? likeT('addDish') : likeT('deleteDish');
      toastr.info(text);
    });
};
